import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import App from './App.tsx'
import './index.css'

// TODO: Error boundary implementation for production
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] Caught error:', error)
    console.error('[ErrorBoundary] Error info:', errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-walrus-black">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-walrus-white mb-4">
              Something went wrong
            </h1>
            <p className="text-walrus-silver mb-8">
              {this.state.error?.message || 'An unexpected error occurred'}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              Reload Page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

// Configure AWS Amplify
console.log('[main.tsx] Configuring AWS Amplify with environment variables:')
console.log('[main.tsx] - VITE_USER_POOL_ID:', import.meta.env.VITE_USER_POOL_ID ? '✓ configured' : '✗ missing')
console.log('[main.tsx] - VITE_USER_POOL_CLIENT_ID:', import.meta.env.VITE_USER_POOL_CLIENT_ID ? '✓ configured' : '✗ missing')
console.log('[main.tsx] - VITE_AWS_REGION:', import.meta.env.VITE_AWS_REGION ? '✓ configured' : '✗ missing')
console.log('[main.tsx] - VITE_S3_BUCKET:', import.meta.env.VITE_S3_BUCKET ? '✓ configured' : '✗ missing')

try {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
        loginWith: {
          email: true,
        },
      },
    },
  })
  console.log('[main.tsx] AWS Amplify configured successfully')
} catch (error) {
  console.error('[main.tsx] Failed to configure AWS Amplify:', error)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

console.log('[main.tsx] React application mounted successfully')
